import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Paper, Button } from "@material-ui/core";

import Loading from "../../loading";
import Header from "../../../partials/header";
import InputFormat from "../../../partials/inputForm";
import Snackbar from "../../snackbar";
import { styles } from "./styles";

class SMSSend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sms: {},
    };
  }
  componentDidMount() {}
  handleChange = (e) => {
    let { sms } = this.state;
    let value = e.target.value;
    let name = e.target.name;
    if (e.target.type === "checkbox") {
      value = e.target.checked ? 1 : 0;
    }
    sms[name] = value;
    this.setState({ sms });
  };
  checkValidate = () => {
    const { t } = this.props;
    const { sms } = this.state;
    let check = true;
    if (!sms.to) {
      this.mSnackbar.handleClick(t("sms_send_error_pls_fill_phone"), "warning");
      check = false;
    } else if (!sms.message) {
      this.mSnackbar.handleClick(
        t("sms_send_error_pls_fill_message"),
        "warning"
      );
      check = false;
    }
    return check;
  };
  handleSubmit = async () => {
    const { t } = this.props;
    const { sms } = this.state;
    if (this.checkValidate()) {
      let data = {
        listPhone: sms.to.split(";"),
        message: sms.message,
      };
      this.loading.startLoading();
      let check = await this.props.sendSMSToListPhone(data);
      this.loading.stopLoading();
      if (!check.code && check.error === 1204) {
        this.mSnackbar.handleClick(
          t("SMS_SEND_SERVICE_NOT_DEVICE_CONNECTED"),
          "error"
        );
      } else {
        this.mSnackbar.handleClick(t("sms_send_successfully"));
      }
    }
  };
  render() {
    const { t, roleId, classes } = this.props;
    const { sms } = this.state;
    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Header
          session={
            roleId.role === "admin"
              ? t("sidebar_superadmin")
              : t("sidebar_manage")
          }
          title={t("sms_title_sms_send")}
          backIcon={true}
          actionBack={() => this.props.history.push("/sms")}
        />
        <Paper className={classes.paper}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <InputFormat
                label={t("sms_manage_title_to")}
                name="to"
                placeholder="0906xxx;0980xxx"
                value={sms.to}
                onChange={this.handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputFormat
                multiline={true}
                label={t("sms_manage_title_message")}
                name="message"
                placeholder={t("sms_manage_title_message")}
                value={sms.message}
                onChange={this.handleChange}
                required
              />
            </Grid>
          </Grid>
          <Grid container justify="flex-end" className={classes.marginTop}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleSubmit}
              className={classes.button}
            >
              {t("sms_send")}
            </Button>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

SMSSend.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  roleId: state.user.user.roleId,
});
const mapDispatch = (dispatch) => ({
  sendSMSToListPhone: dispatch.sms.sendSMSToListPhone,
});
export default translate("translations")(
  withStyles(styles, { withTheme: true })(
    connect(mapState, mapDispatch)(SMSSend)
  )
);
